/**
 * Property brush — paints collision/occlusion/water properties on tile layers.
 * Properties stored as boolean arrays in layer.properties.
 */
export class PropertyBrush {
  constructor(state, mapCanvas) {
    this.state = state;
    this.mapCanvas = mapCanvas;
    this.propertyType = 'collision';
    this._painting = false;
    this._paintValue = true;

    // Listen for property type changes from the Toolbar selector
    this.state.onChange('propertyBrushType', (type) => {
      if (type) this.setPropertyType(type);
    });
  }

  setPropertyType(type) {
    this.propertyType = type;
  }

  onDown(tx, ty) {
    this._painting = true;
    // Toggle: if current value is true, paint false; otherwise paint true
    const current = this._getPropValue(tx, ty);
    this._paintValue = !current;
    this._applyProp(tx, ty);
  }

  onMove(tx, ty) {
    if (!this._painting) return;
    this._applyProp(tx, ty);
  }

  onUp() {
    this._painting = false;
  }

  _getPropValue(tx, ty) {
    const state = this.state;
    const layerIndex = state.get('activeLayerIndex');
    const layer = state.get('layers')[layerIndex];
    if (!layer) return false;
    const props = layer.properties || {};
    const propData = props[this.propertyType];
    if (!propData || !Array.isArray(propData.value)) return false;
    const mapW = state.get('mapWidth');
    return !!propData.value[ty * mapW + tx];
  }

  _applyProp(tx, ty) {
    const state = this.state;
    const mapW = state.get('mapWidth');
    const mapH = state.get('mapHeight');
    if (tx < 0 || ty < 0 || tx >= mapW || ty >= mapH) return;

    const layerIndex = state.get('activeLayerIndex');
    const layer = state.get('layers')[layerIndex];
    if (!layer) return;

    if (!layer.properties) layer.properties = {};
    if (!layer.properties[this.propertyType]) {
      layer.properties[this.propertyType] = {
        type: 'bool',
        value: new Array(mapW * mapH).fill(false),
      };
    }

    layer.properties[this.propertyType].value[ty * mapW + tx] = this._paintValue;
    state.set('dirty', true);
  }
}
